import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LuCircleCheck, LuCircleX } from 'react-icons/lu';
import API from '../../api/axios';
import { Button } from '../../components/ui';
import { fmtF } from '../../theme';
import '../../components/abonnement/Abonnement.css';

/** Page de retour après le guichet CinetPay : attend la confirmation du paiement. */
export default function RetourPaiement() {
  const navigate = useNavigate();
  const transactionId = new URLSearchParams(window.location.search).get('transaction_id');
  const [tx, setTx] = useState(null);
  const [erreur, setErreur] = useState('');
  const essais = useRef(0);

  useEffect(() => {
    if (!transactionId) { setErreur('Référence de paiement manquante.'); return undefined; }
    let fini = false;
    let minuteur;
    const verifier = async () => {
      try {
        const r = await API.get(`/abonnements/transactions/${encodeURIComponent(transactionId)}`);
        setTx(r.data.transaction);
        essais.current += 1;
        // Mobile Money : la validation sur le téléphone peut prendre un peu de temps
        if (r.data.transaction.statut === 'en_attente' && essais.current < 40 && !fini) minuteur = setTimeout(verifier, 4000);
      } catch (e) {
        setErreur(e?.response?.data?.message?.replace(/^❌\s*/, '') || 'Impossible de vérifier le paiement.');
      }
    };
    verifier();
    return () => { fini = true; clearTimeout(minuteur); };
  }, [transactionId]);

  const retour = () => navigate('/proprietaire/abonnement');
  const statut = erreur ? 'erreur' : tx?.statut || 'chargement';

  return (
    <main className="ab-page-centre" style={{ '--accent': '#EA580C' }}>
      <div className="ab-carte-centre">
        {statut === 'paye' && (
          <>
            <div className="ab-icone-statut is-ok"><LuCircleCheck aria-hidden /></div>
            <h1>Paiement confirmé</h1>
            <p>
              {tx.objet === 'recharge'
                ? <>Votre solde a été crédité de <strong className="ab-num">{fmtF(tx.montant)}</strong>.</>
                : <>Abonnement de <strong>{tx.etablissement_nom}</strong> prolongé de {tx.mois} mois (<span className="ab-num">{fmtF(tx.montant)}</span>).</>}
            </p>
            {tx.frais > 0 && <p className="ab-sub">Frais de paiement en ligne : <span className="ab-num">{fmtF(tx.frais)}</span> (total payé : <span className="ab-num">{fmtF(tx.montant + tx.frais)}</span>).</p>}
            <Button onClick={retour} style={{ marginTop: 8 }}>Retour à mon abonnement</Button>
          </>
        )}
        {statut === 'echoue' && (
          <>
            <div className="ab-icone-statut is-ko"><LuCircleX aria-hidden /></div>
            <h1>Paiement non abouti</h1>
            <p>Le paiement a été refusé ou annulé. Aucun montant n'a été prélevé.</p>
            <Button onClick={retour} style={{ marginTop: 8 }}>Réessayer</Button>
          </>
        )}
        {(statut === 'en_attente' || statut === 'chargement') && (
          <>
            <div className="ab-icone-statut is-attente"><div className="ab-spinner" aria-hidden /></div>
            <h1>Paiement en cours de confirmation</h1>
            <p>Si vous payez par Mobile Money, validez l'opération sur votre téléphone. Cette page se met à jour automatiquement.</p>
            {tx?.statut === 'en_attente' && essais.current >= 40 && (
              <p className="ab-sub">Toujours en attente : vous recevrez une notification dès que le paiement sera confirmé.</p>
            )}
            <Button variant="secondary" onClick={retour} style={{ marginTop: 8 }}>Retour à mon abonnement</Button>
          </>
        )}
        {statut === 'erreur' && (
          <>
            <div className="ab-icone-statut is-ko"><LuCircleX aria-hidden /></div>
            <h1>Vérification impossible</h1>
            <p>{erreur}</p>
            <Button onClick={retour} style={{ marginTop: 8 }}>Retour à mon abonnement</Button>
          </>
        )}
      </div>
    </main>
  );
}
